import clsx from 'clsx'
import React from 'react'

import {Typographyv2 as Typography} from '../v2/typography'
import {useLangPopover} from './hooks'
import {LangPopover} from './LangPopover'
import * as classes from './LangSwitcher.classes'

type Props = {
  size?: 's' | 'm'
  invert?: boolean
  lang: string
  languages: string[]
  zIndex?: number
}

const FALLBACK_LOCALE = 'ru'

const LangSwitcher: React.FC<Props> = ({languages, lang, invert, size = 'm', zIndex}) => {
  const {anchorEl, opened, closeHandler, openHandler} = useLangPopover()
  const selectedLanguage = languages.includes(lang) ? lang : FALLBACK_LOCALE

  return (
    <>
      <Typography
        ref={anchorEl}
        className={clsx(classes.langSwitcher, invert && classes.langSwitcherInvert)}
        Component="span"
        onClick={openHandler}
        thickness="bold"
        variant={size === 's' ? 'body2' : 'body1'}
      >
        {selectedLanguage}
      </Typography>
      <LangPopover
        anchorEl={anchorEl}
        lang={lang}
        languages={languages}
        onClose={closeHandler}
        opened={opened}
        zIndex={zIndex}
      />
    </>
  )
}

export default LangSwitcher
